export default __webpack_public_path__ + "static/media/balkouras-nicos-8tadBT_8Gag-unsplash-original.e1c7bd46.jpg";